export default __webpack_public_path__ + "static/media/ShortLivedBranches.7b6e11c4.gif";